import './style.scss'
import { Button, Input, message, Modal, Radio } from 'antd'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Api from '@/api/home'
import { PlusOutlined } from '@ant-design/icons'

interface IProps {
  avatarId?: number
  onSuccess?: () => void
  onCancel?: () => void
}

const Groups: FC<IProps> = (props) => {
  const { t } = useTranslation(['avatar', 'system'])
  const { avatarId, onSuccess, onCancel } = props
  const [toGroupId, setToGroupId] = useState<number>()
  const [groups, setGroups] = useState<any[]>([])
  const [addGroupShow, setAddGroupShow] = useState(false)
  const [groupName, setGroupName] = useState('')

  useEffect(() => {
    if (avatarId) {
      getGroups()
    }
  }, [avatarId])

  const onSelectChange = (id: number) => {
    if (toGroupId !== id) {
      setToGroupId(id)
    } else {
      setToGroupId(undefined)
    }
  }

  const getGroups = async () => {
    const res = await Api.getDigitalHumanGroups()
    setGroups(res?.list || [])
  }

  const showAddGroup = () => {
    setAddGroupShow(true)
  }

  const addGroup = async () => {
    const res = await Api.addDigitalGroup({
      title: groupName
    })
    getGroups()
    setToGroupId(res.id)
    setAddGroupShow(false)
    setGroupName('')
  }

  const moveGroup = async () => {
    await Api.updateDigitalHumans(avatarId as number, {
      group_id: toGroupId
    })

    message.success(t('system.move_success'))
    onSuccess?.()
    onCancel?.()
  }

  return (
    <>
      <Modal
        width={510}
        okButtonProps={{
          disabled: !toGroupId
        }}
        title={t('avatar.move_to')}
        open={!!avatarId}
        okText={t('system.move')}
        className="commom-modal group-modal"
        onCancel={onCancel}
        onOk={moveGroup}
      >
        <div className="group-list">
          {groups.map((g) => (
            <div key={g.id} className="list-item" onClick={onSelectChange.bind(this, g.id)}>
              <Radio.Group value={toGroupId}>
                <Radio value={g.id}></Radio>
              </Radio.Group>
              {g.title}
            </div>
          ))}
          <Button className="btn-add" icon={<PlusOutlined />} onClick={showAddGroup}>
            {t('system.create_new')}
          </Button>
        </div>
      </Modal>

      <Modal
        title={t('avatar.create_new_avatar')}
        open={addGroupShow}
        width={400}
        className="commom-modal group-add-modal"
        onOk={addGroup}
        onCancel={() => setAddGroupShow(false)}
      >
        <div className="group-add-content">
          <Input
            value={groupName}
            placeholder={t('avatar.input_avatar_name')}
            onChange={(e) => setGroupName(e.target.value)}
          />
        </div>
      </Modal>
    </>
  )
}

export default memo(Groups)
